import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import CenterModalWindow from '../CenterModalWindow/CenterModalWindow';
import '../CenterModalWindow/CenterModalWindow.css';
import './ConfirmDangerModal.css';

/**
 * Reusable destructive confirmation dialog (CenterModalWindow).
 */
export default function ConfirmDangerModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  subtitle = '',
  description,
  confirmLabel = 'Confirm',
  confirmBusyLabel,
  cancelLabel = 'Cancel',
  busy = false,
  icon = FiTrash2,
  width = 'min(420px, calc(100vw - 32px))',
}) {
  const Icon = icon;

  const handleConfirm = async () => {
    if (busy || !onConfirm) return;
    await onConfirm();
  };

  const busyLabel = confirmBusyLabel || confirmLabel;

  return (
    <CenterModalWindow
      isOpen={isOpen}
      onClose={onClose}
      width={width}
      height="auto"
      contentStyle={{ height: 'auto', maxHeight: 'min(90dvh, 520px)' }}
      contentClassName="confirm-danger-modal"
    >
      <div className="confirm-danger-modal__body" data-modal-scroll-port>
        <div className="confirm-danger-modal__head">
          <div className="confirm-danger-modal__icon" aria-hidden>
            <Icon />
          </div>
          <div className="confirm-danger-modal__head-text">
            <h3 className="confirm-danger-modal__title">{title}</h3>
            {subtitle ? <p className="confirm-danger-modal__subtitle">{subtitle}</p> : null}
          </div>
        </div>
        {description ? <p className="confirm-danger-modal__desc">{description}</p> : null}
        <div className="confirm-danger-modal__actions">
          <button type="button" className="confirm-danger-modal__cancel" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button type="button" className="confirm-danger-modal__confirm" onClick={handleConfirm} disabled={busy}>
            <FiTrash2 aria-hidden />
            {busy ? busyLabel : confirmLabel}
          </button>
        </div>
      </div>
    </CenterModalWindow>
  );
}
